export function meanStd(numbers) {
  const mean = numbers.reduce((acc, val) => acc + val, 0) / numbers.length;
  const sumOfSquaredDifferences = numbers
    .reduce((acc, val) => acc.concat((val - mean) ** 2), [])
    .reduce((acc, val) => acc + val, 0);
  const stdev = Math.sqrt(sumOfSquaredDifferences / (numbers.length - 1));
  return { mean, stdev };
}
